import { Grid, SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { useState } from 'react';

type IconProps = {
  color?: string;
  hoverColor?: string;
  style?: React.CSSProperties;
  props?: any;
};

const WhatsappIcon = ({ color = RoutalPalette.neutral00, hoverColor, style, props }: IconProps) => {
  const [isHover, setHover] = useState(false);
  return (
    <Grid onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <SvgIcon
        {...props}
        viewBox="0 0 17 17"
        style={{ width: `17px`, height: `17px`, color: isHover && hoverColor ? hoverColor : color, style }}
      >
        <path d="M12.05,9.95c-.21-.1-1.22-.6-1.4-.66s-.32-.1-.46,.1-.53,.66-.65,.8-.24,.14-.44,.05c-.61-.24-1.17-.59-1.65-1.02-.45-.42-.83-.9-1.14-1.42-.12-.21-.01-.32,.09-.42s.21-.24,.31-.36c.08-.11,.15-.22,.2-.34,.06-.12,.06-.26-.02-.36-.34-.49-1.53-1.88-1.53-1.88-.18,.03-.31,.09-.54,.27-.47,.44-.7,1.03-.69,1.68,.07,.77,.36,1.5,.84,2.11,.88,1.31,2.09,2.38,3.51,3.08,.49,.21,.87,.33,1.17,.43,.42,.13,.86,.16,1.29,.08,.58-.12,1.08-.47,1.39-.98,.14-.31,.18-.65,.12-.98m-4.13,4.88h-.01c-1.22,0-2.42-.33-3.48-.95l-.25-.15-2.58,.67,.69-2.51-.16-.26C.54,8.63,1.52,4.43,4.72,2.44c2.69-1.67,6.18-1.27,8.42,.98,1.28,1.27,2,3,2,4.81-.01,3.76-3.07,6.8-6.83,6.8M14.12,2.44C12.57,.92,10.47,.07,8.3,.07,3.78,.05,.11,3.69,.09,8.2c0,1.45,.37,2.87,1.1,4.13L.02,16.57l4.36-1.14c1.21,.65,2.56,.99,3.93,1h0c4.53,0,8.2-3.65,8.22-8.18,0-2.17-.85-4.28-2.39-5.81" />
      </SvgIcon>
    </Grid>
  );
};

export default WhatsappIcon;
